/**
 * Quick Amount Selector
 * 
 * Handles quick amount button clicks to auto-populate deposit amount input.
 * Follows SOLID principles - Single Responsibility: manages only quick amount selection.
 * 
 * @package betbeast
 */

export class QuickAmountSelector {
    constructor(modalElement) {
        this.modal = modalElement;
        this.amountInput = null;
        
        if (!this.modal) {
            console.warn('Modal element not provided to QuickAmountSelector');
            return;
        }
        
        this.init();
    }
    
    /**
     * Initialize quick amount button listeners
     */
    init() {
        // Get the amount input
        this.amountInput = this.modal.querySelector('.wallet-deposit-amount-input');
        
        if (!this.amountInput) {
            console.warn('Amount input not found in QuickAmountSelector');
            return;
        }
        
        // Get all quick amount buttons
        const quickAmountButtons = this.modal.querySelectorAll('.wallet-deposit-quick-amount');
        
        quickAmountButtons.forEach(button => {
            button.addEventListener('click', (e) => this.handleQuickAmountClick(e.target));
        });
        
        // Remove active state when user manually changes input
        this.amountInput.addEventListener('input', () => this.removeAllActiveStates());
    }
    
    /**
     * Handle quick amount button click
     * @param {HTMLElement} button - The clicked button element
     */
    handleQuickAmountClick(button) {
        const amount = button.getAttribute('data-amount');
        
        if (!amount) {
            console.warn('Quick amount button has no data-amount attribute');
            return;
        }
        
        // Set the amount input value
        this.amountInput.value = amount;
        
        // Trigger input event to clear any error/success states
        this.amountInput.dispatchEvent(new Event('input', { bubbles: true }));
        
        // Trigger blur event to validate the amount
        this.amountInput.dispatchEvent(new Event('blur', { bubbles: true }));
        
        // Optional: Add visual feedback
        this.addActiveState(button);
    }
    
    /**
     * Add temporary active state to clicked button
     * @param {HTMLElement} button - The clicked button element
     */
    addActiveState(button) {
        // Remove active state from all buttons
        this.removeAllActiveStates();
        
        // Add active state to clicked button
        button.classList.add('is-active');
    }
    
    /**
     * Remove active state from all quick amount buttons
     */
    removeAllActiveStates() {
        const allButtons = this.modal.querySelectorAll('.wallet-deposit-quick-amount');
        allButtons.forEach(btn => btn.classList.remove('is-active'));
    }
}
